"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var NoOpVideoElementFactory = /*#__PURE__*/function () {
  function NoOpVideoElementFactory() {
    _classCallCheck(this, NoOpVideoElementFactory);
  }
  _createClass(NoOpVideoElementFactory, [{
    key: "create",
    value: function create() {
      var element = {
        clientWidth: 400,
        clientHeight: 300,
        width: 400,
        height: 300,
        videoWidth: 400,
        videoHeight: 300,
        style: {
          transform: ''
        },
        hasAttribute: function hasAttribute() {
          return false;
        },
        removeAttribute: function removeAttribute() {},
        setAttribute: function setAttribute() {},
        srcObject: false,
        pause: function pause() {},
        play: function play() {
          return Promise.resolve();
        }
      };
      // @ts-ignore
      return element;
    }
  }]);
  return NoOpVideoElementFactory;
}();
exports.default = NoOpVideoElementFactory;